import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { supabase } from '@/integrations/supabase/client';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/components/auth/AuthProvider';
import { useToast } from '@/hooks/use-toast';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { toast } = useToast();

  useEffect(() => {
    const checkAdminStatus = async () => {
      console.log('AdminLogin: Checking user status:', user);
      
      if (user) {
        console.log('AdminLogin: User found, checking admin privileges for ID:', user.id);
        
        try {
          const { data: admin, error } = await supabase
            .from('admins')
            .select('*')
            .eq('user_id', user.id)
            .single();

          console.log('AdminLogin: Admin check result:', { admin, error });

          if (error) {
            console.error('AdminLogin: Error checking admin status:', error);
            throw error;
          }

          if (admin) {
            console.log('AdminLogin: Admin access granted, redirecting to dashboard');
            navigate('/admin-web/dashboard');
          } else {
            console.log('AdminLogin: User is not an admin');
            toast({
              title: "Access Denied",
              description: "You don't have admin privileges",
              variant: "destructive"
            });
            navigate('/');
          }
        } catch (error) {
          console.error('AdminLogin: Error during admin check:', error);
          toast({
            title: "Error",
            description: "An error occurred while checking admin privileges",
            variant: "destructive"
          });
          navigate('/');
        }
      }
    };

    checkAdminStatus();
  }, [user, navigate, toast]);

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto max-w-md px-4 py-8">
        <div className="rounded-lg border bg-card p-8 text-card-foreground shadow-sm">
          <h2 className="text-2xl font-bold text-center mb-6">CurlyScan Admin</h2>
          <Auth
            supabaseClient={supabase}
            appearance={{ theme: ThemeSupa }}
            theme="light"
            providers={[]}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;